exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead th[data-v-9d7ac0fe]{background:#eee}.table tbody tr:last-child td[data-v-9d7ac0fe],.table tbody tr:last-child th[data-v-9d7ac0fe],.table thead th[data-v-9d7ac0fe]{border:1px solid #ddd}", ""]);

// exports
